import { createReducer } from 'typesafe-actions';
import fileGenerationActions from './actions';
import { FileGenerationState, FileGenerationTypes } from './types';

const INITIAL_STATE: FileGenerationState = {
  isLoading: false,
  error: 0,
};

export type RootExportsActions =
  | ReturnType<typeof fileGenerationActions.request>
  | ReturnType<typeof fileGenerationActions.success>
  | ReturnType<typeof fileGenerationActions.failure>;

const exportsReducer = createReducer<FileGenerationState, RootExportsActions>(
  INITIAL_STATE,
  {
    [FileGenerationTypes.FileGenerationRequest]: () => {
      return {
        ...INITIAL_STATE,
        isLoading: true,
      };
    },
    [FileGenerationTypes.FileGenerationSuccess]: () => {
      return {
        isLoading: false,
        error: 0,
      };
    },
    [FileGenerationTypes.FileGenerationFailure]: (_, action) => {
      const { payload } = action;
      return {
        isLoading: false,
        error: payload,
        isSuccess: false,
      };
    },
  }
);

export default exportsReducer;
